import { call, put, takeEvery } from "redux-saga/effects";
import Constants from "../../Action/Constants";
import { ErrorHandlerSequence } from "../Sequences/ErrorHandlerSequence";
import { ActionInterface } from "../../Interface/ActionInterface";
import { PropertyInterface } from "../../Entity/Entities/Property/PropertyInterface";
import Translator from "../../Translation/Translator";
import Http from "../../Http/Http";

export default function* propertyDelete(action: ActionInterface): any {
  try {
    yield put({
      type: Constants.PAGE_PROPERTY_DELETE_REQUEST
    });

    yield call(Http.delete, `properties/${action.payload?.property.id}`);

    const property: PropertyInterface = action.payload?.property.reinitialize({
      removed: true
    });

    yield put({
      type: Constants.PAGE_PROPERTY_DELETE_SUCCESS,
      payload: {
        property: property
      }
    });

    yield put({
      type: Constants.SNACKBAR_ADD_MESSAGE,
      payload: {
        type: "success",
        message: Translator.trans("snackbar-message-property-removed-successfully")
      }
    });

    if (action.hasOwnProperty("onSuccess") === true) {
      action.onSuccess.call(this);
    }
  } catch (err) {

    yield ErrorHandlerSequence(err, action);

    yield put({
      type: Constants.PAGE_PROPERTY_DELETE_FAILURE,
      payload: {
        err: err
      }
    });

  }
}

export function* watchPropertyDelete() {
  yield takeEvery(Constants.PAGE_PROPERTY_DELETE_START, propertyDelete);
}
